import { REQUEST_DOMAIN_RENEWAL } from '@/redux/actions/actionsTypes';


const initialState = {
  loading: false,
};

export default function domainRenewal(state = initialState, action) {
  switch (action.type) {
    case REQUEST_DOMAIN_RENEWAL:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}
